<style scoped>
.product-brand {
    font-size: 1.375rem;
    @apply font-black;
}
.product-name {
    @apply text-xl font-extrabold;
}
.product-size {
    @apply text-xs;
}

.prize {
    @apply border-2 border-transparent;
}

.won-prize {
    box-shadow: 0em 0em 1em 0.5em #fcbc00;
    @apply border-orange-100 !important;
}

@screem sm {
    .prize {
        @apply border-8;
    }
}
</style>

<template>
    <modal class="modal-2xl" type="custom">
        <div v-if="!showDrawResult" class="flex flex-col items-center">
            <div class="w-full max-w-full flex flex-wrap">
                <div
                    v-for="(p, pi) in prmtEvntPrzList"
                    :key="pi"
                    class="w-1/3 p-2"
                >
                    <productImage
                        :product="p"
                        :imageType="'small'"
                        class="prize"
                        :class="{
                            ' won-prize':
                                pi === currentAnimationHighligntedIndex
                        }"
                        @loaded="loadedImageCount++"
                    />
                </div>
            </div>
            <errorBox
                class="text-sm sm:text-base"
                :message="errors.server"
                :showImage="true"
            />

            <div
                v-if="!!loading || loadedImageCount !== prmtEvntPrzList.length"
                class="flex items-center"
            >
                <spinner />
                <div class="ml-4">{{ '載入中' }}</div>
            </div>
            <div class="flex flex-col items-start w-full">
                <loadingButton
                    v-if="
                        !loading && loadedImageCount === prmtEvntPrzList.length
                    "
                    class="mx-auto btn btn-primary sm:text-3xl sm:px-16"
                    :status="startDrawBtnStatus"
                    @click="startLuckyDraw"
                    @successShown="showDrawResult = true"
                >
                    {{ '開始!' }}
                </loadingButton>
                <button
                    class="ml-auto text-secondary underline sm:text-lg"
                    @click="$emit('hide')"
                >
                    {{ '等陣先玩' }}
                </button>
            </div>
        </div>
        <div v-if="!!showDrawResult" class="flex flex-col">
            <bubble>
                <template #image>
                    <img :src="bubbleImg" class="w-16 sm:w-20" />
                </template>
                <div class="text-lg sm:text-3xl">
                    {{ '恭喜！您得到的獎品是...' }}
                </div>
            </bubble>
            <div class="w-5/6 max-w-sm mx-auto">
                <div class="flex flex-col items-center">
                    <productImage
                        :product="wonPrmtEvntPrz"
                        :imageType="'small'"
                    />
                    <div class="product-brand">
                        {{ wonPrmtEvntPrz.prodBrndName || '&emsp;' }}
                    </div>
                    <contentNewLine
                        v-if="$config.showProdName"
                        class="product-name"
                        :value="wonPrmtEvntPrz.prodName"
                    />
                    <div class="product-size">
                        {{ wonPrmtEvntPrz.prodSizeText }}
                    </div>
                </div>
            </div>
            <div class="flex flex-col mt-4">
                <button
                    class="mx-auto btn btn-primary sm:text-3xl sm:px-16"
                    @click="playAgain"
                >
                    {{ '再玩一次!' }}
                </button>
                <button
                    class="ml-auto text-secondary underline sm:text-lg"
                    @click="$emit('hide')"
                >
                    {{ '等陣先玩' }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import modal from './modal.vue';
import { instance } from '../utils/ajax';
import errorBox from './errorBox.vue';
import productImage from './productImage.vue';
import contentNewLine from './contentNewLine';
import Spinner from './spinner.vue';
import loadingButton from './loadingButton.vue';
import bubble from './bubble.vue';
import img2s112 from '../assets/img/2-112.png';

async function previewLuckyDrawItems(promotionEventId) {
    try {
        let result = await instance.post('/api/event/previewEventPrizes', {
            promotionEventId
        });
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error previewLuckyDrawItems');
        return { success: false, all: 'error.connect' };
    }
}

async function getLuckyDrawResult({
    promotionEventId,
    transactionId,
    transactionTimestamp,
    hashToken
}) {
    try {
        let result = await instance.post('/api/event/startEvent', {
            promotionEventId,
            transactionId,
            transactionTimestamp,
            hashToken
        });
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error getLuckyDrawResult');
        return { success: false, all: 'error.connect' };
    }
}

export default {
    components: {
        modal,
        errorBox,
        productImage,
        contentNewLine,
        Spinner,
        loadingButton,
        bubble
    },
    props: {
        promotionEventId: { type: String, required: true }
    },
    data() {
        return {
            loading: false,
            errors: {},
            startDrawBtnStatus: undefined,
            loadedImageCount: 0,
            currentAnimationHighligntedIndex: undefined,
            //
            transactionId: undefined,
            transactionTimestamp: undefined,
            hashToken: undefined,
            prmtEvntPrzList: [],
            //
            wonPrmtEvntPrzKey: undefined,
            showDrawResult: false,
            bubbleImg: img2s112
        };
    },
    computed: {
        event() {
            return (this.$store.state.promotionEvents || []).find(
                p => p.prmtEvntId === this.promotionEventId
            );
        },
        custTknCnt() {
            return this.event?.custTknCnt || 0;
        },
        wonPrmtEvntPrz() {
            return (this.prmtEvntPrzList || []).find(
                p => p.id === this.wonPrmtEvntPrzKey
            );
        }
    },
    async created() {
        await this.reloadPrmtEvntInfoFromServer();
    },
    methods: {
        async reloadPrmtEvntInfoFromServer() {
            this.loading = true;
            this.transactionId = undefined;
            this.transactionTimestamp = undefined;
            this.hashToken = undefined;
            this.prmtEvntPrzList = [];
            this.wonPrmtEvntPrzKey = undefined;
            this.currentAnimationHighligntedIndex = undefined;
            this.loadedImageCount = 0;
            this.errors = {};
            this.startDrawBtnStatus = undefined;
            this.showDrawResult = false;

            const result = await previewLuckyDrawItems(this.promotionEventId);
            if (result.success) {
                this.updateEventRemainingTokenNumber(
                    result.data.remainingToken
                );
                this.transactionId = result.data.transactionId;
                this.transactionTimestamp = result.data.transactionTimestamp;
                this.hashToken = result.data.hashToken;
                this.prmtEvntPrzList = result.data.prmtEvntPrzList || [];
            } else {
                this.errors = result?.data?.errors;
            }
            this.loading = false;
        },
        async startLuckyDraw() {
            this.startDrawBtnStatus = 'loading';

            const result = await getLuckyDrawResult({
                promotionEventId: this.promotionEventId,
                transactionId: this.transactionId,
                transactionTimestamp: this.transactionTimestamp,
                hashToken: this.hashToken
            });
            if (result.success) {
                this.updateEventRemainingTokenNumber(
                    result.data.remainingToken
                );
                this.wonPrmtEvntPrzKey = result.data.wonPrmtEvntPrzKey;
                this.startAnimation();
            } else {
                this.errors = result.data.errors;
                this.startDrawBtnStatus = undefined;
            }
        },
        updateEventRemainingTokenNumber(remainingToken) {
            this.$store.commit('setPromotionEventRemainingToken', {
                eventId: this.promotionEventId,
                remainingToken
            });
        },
        startAnimation() {
            const initialTimeout = 20; // 20ms
            const finalTimeout = 200; // 200ms

            const targetIndex = this.prmtEvntPrzList.indexOf(
                this.wonPrmtEvntPrz
            );

            this.currentAnimationHighligntedIndex = 0;
            const timeout = ts =>
                setTimeout(() => {
                    this.currentAnimationHighligntedIndex =
                        (this.currentAnimationHighligntedIndex + 1) %
                        this.prmtEvntPrzList.length;

                    ts = Math.min(ts + 10, finalTimeout);

                    if (
                        ts === finalTimeout &&
                        this.currentAnimationHighligntedIndex === targetIndex
                    ) {
                        this.startDrawBtnStatus = 'success';
                        return;
                    } else {
                        timeout(ts);
                    }
                }, ts);
            timeout(initialTimeout);
        },
        playAgain() {
            if (!this.custTknCnt) {
                this.$emit('hide');
                return;
            }
            this.reloadPrmtEvntInfoFromServer();
        }
    }
};
</script>
